<template>
    <div class="adminUserList">
        <div class="row">
            <div class="col-md-5">
                <Breadcumb title="Liste des entreprises" :breadcumb-data="breadcumbData">
                    <b-btn v-bind:to="'/dashboard/administration/companies/add/'" class="mt-3 mb-3" variant="primary" style="float:right">
                        Ajouter une entreprise
                    </b-btn>
                </Breadcumb>
            </div>
        </div>
        <b-card no-body class="cardcontainer">
            <!-- Table controls -->
            <b-card-body>
                <b-table
                        v-if="companiesData"
                        :items="companiesData"
                        :fields="fields"
                        :striped="true"
                        :bordered="true"
                        class="card-table">
        
                    <template slot="Nom" slot-scope="data">
                        {{data.item.name}}
                    </template>
                    <template slot="Lien" slot-scope="data">
                        {{ data.item.hash }}
                    </template>
                    
                </b-table>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
    import {GET_COMPANIES_REQUEST, GET_HIERARCHICAL_COMPANIES_REQUEST} from '../../_store/company/actiontypes'
    import Breadcumb from '../../components/breadcumb'
    

    export default {
        name: 'adminUserList',
        components: { Breadcumb },
        mounted() {
            this.$store.dispatch(GET_COMPANIES_REQUEST)
                .then(response => {
                    this.companiesData = response.data.companies
                });
        },
        data() {
            return {
                treeData: [],
                breadcumbData: [
                    { text: this.$t('welcome'), href: '/dashboard/' },
                    { text: 'Gestion entreprise', active: true },
                ],
                dataUrl: 'json/pages_users_list.json',
                fields: [
                    {
                        key: 'Nom',
                        sortable: false,
                        tdClass: 'align-middle'
                    }, {
                        key: 'Lien',
                        sortable: false,
                        tdClass: 'align-middle'
                    },
                ],
                companiesData: [],
                currentPage: 1
            };
        },
        layout(context) {
            return 'layout';
        },
        methods: {},
    };
</script>
